import { render } from "./ModalCreaPresenza.vue?vue&type=template&id=e52bd920&scoped=true"
import script from "./ModalCreaPresenza.vue?vue&type=script&lang=js"
export * from "./ModalCreaPresenza.vue?vue&type=script&lang=js"

import "./ModalCreaPresenza.vue?vue&type=style&index=0&id=e52bd920&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_perla_1770288832097110005/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e52bd920"]])

export default __exports__